module.exports = __webpack_public_path__ + "static/img/dec_paper_01.b5b49e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/events/dec_paper_01.png
// module id = bgkO
// module chunks = 0